import { encode, decode } from 'js-base64';

export function objToBase64(object: {}) {
  return encode(JSON.stringify(object));
}
export function base64ToObj(base64String: string) {
  return JSON.parse(decode(base64String));
}
